/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
import { AzureADContext } from "cms/auth/context/AzureADContext";

const useAuth = () => {
    
    const context = useContext(AzureADContext);
    if (!context) {
        throw new Error("Auth context must be used inside Auth provider.");
    }
    return context;
};

export { useAuth };
